import type { DirectShearReading } from '../types/directShearReading';

/**
 * True for a Direct Shear reading that belongs to the RESULT tables — i.e.
 * not a machine seating-phase row (`IsSeating`, mig 108).
 *
 * Seating rows are kept in the database (they document the bedding-in ramp
 * the machine records before shearing starts) but they are NOT results: they
 * sit at zero horizontal displacement and near-zero stress, so they are
 * excluded from the entry grid, the peak/residual analysis and EVERY chart —
 * including the Shear-vs-Normal stress path (BUG-2026-0199 rework, 2026-09-17:
 * "only plot the data in the result tables, don't force it to start at 0,0";
 * this deliberately reverses PR #423's KeyLAB-style 0-start ramp).
 */
export const isResultReading = (r: Pick<DirectShearReading, 'IsSeating'>): boolean =>
  r.IsSeating !== true;
